export default {
    findBySlug(events, eventSlug) {
        return events.filter(event => {
            return this.slugFor(event) === eventSlug
        }).shift()
    },
    slugFor(event) {
        const slug = require('slug')
        return event.campusEventId + '-' + slug(event.title)
    }
}
